module.exports = __webpack_public_path__ + "VIPV30.png?bed30ffcd1297fcccc22072c6f75764f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV30.png
// module id = 126
// module chunks = 0